
import React, { Fragment, useContext } from "react";
import TabbedView from "../../../components/lists/TabbedView/TabbedView";
import TabbedViewPage from "../../../components/lists/TabbedView/TabbedViewPage";
import { SessionContext } from "../../../utility/useSession";
import DeviceConfigList from "./DeviceConfigList";
import PimTransactionsView from "./PimTransactionsView";
import { useTranslation } from "react-i18next";

const DeviceManagerView = () => {
    const session = useContext(SessionContext);
    const { t } = useTranslation();

    if (session.current.site == null) {
        return <Fragment />;
    }

    return <TabbedView>
        <TabbedViewPage visible={session.current.site.preferences.enable_device_manager == true} title={t("mobile.configuration")}>
            <DeviceConfigList />
        </TabbedViewPage>
        <TabbedViewPage title={t("booking.labels.transactions")}>
            <PimTransactionsView />
        </TabbedViewPage>
    </TabbedView>;
}
export default DeviceManagerView;